// The API's query-string convention for any query object: an array goes out as
// repeated keys (?kinds=1&kinds=2), and an empty string, undefined or null is
// left out. Lifted unchanged from useOrderApi; GET /invoices/me uses it too.
export const buildQueryString = (params: object): string => {
    const searchParams = new URLSearchParams();
    const entries: [string, unknown][] = Object.entries(params);

    entries.forEach(([key, value]) => {
        if (value === "" || value === undefined || value === null) {
            return;
        }

        if (Array.isArray(value)) {
            value.forEach((item) => searchParams.append(key, String(item)));
        } else {
            searchParams.append(key, String(value));
        }
    });

    return searchParams.toString();
};
